import * as t from "io-ts";

export const RefServiceConditionCodec = t.intersection([
  t.type({
    code: t.string,
    description: t.string,
    doNotUse: t.boolean,
  }),
  t.partial({}),
]);

export type RefServiceCondition = t.TypeOf<typeof RefServiceConditionCodec>;

export const RefServiceModeCodec = t.intersection([
  t.type({
    code: t.string,
    name: t.string,
    description: t.string,
    doNotUse: t.boolean,
  }),
  t.partial({}),
]);

export type RefServiceMode = t.TypeOf<typeof RefServiceModeCodec>;

export const RefServiceStatusCodec = t.intersection([
  t.type({
    code: t.string,
    description: t.string,
    doNotUse: t.boolean,
  }),
  t.partial({}),
]);

export type RefServiceStatus = t.TypeOf<typeof RefServiceStatusCodec>;

export const RefServiceStatusFacetCodec = t.intersection([
  t.type({
    code: t.string,
    description: t.string,
    doNotUse: t.boolean,
  }),
  t.partial({}),
]);

export type RefServiceStatusFacet = t.TypeOf<typeof RefServiceStatusFacetCodec>;

export const refServiceStatusSeverity: Record<string, number> = {
  "NEEDS_SERVICE": 0,
  "BLOCKED": 0,
  "IN_PROGRESS": 1,
  "UNKNOWN": 2,
  "TREATED": 3,
  "CLEAR": 3,
  "CLOSED": 3,
  "OPEN": 3,
};

export const getRefServiceStatusSeverity = (status: string): number => refServiceStatusSeverity[status] ?? 2;
